<template>
    <!-- Family Info Modal -->
				<v-dialog v-model="modalDialog" max-width="725px">
						<div class="modal-content">
							<div class="modal-header">
								<h5 class="modal-title"> Next of Kin Information</h5>
								<button type="button" class="close" @click="method(null)">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div class="modal-body">
								<form @submit.prevent="postNextOfKin">
										<div class="card">
											<div class="card-body">
												<h3 class="card-title">Next of Kin Information </h3>
												<div class="row">
                                                    <div class="col-md-12">
                                                        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="error">
								                            <strong>Error!</strong> {{error}}
								                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
									                            <span aria-hidden="true">&times;</span>
								                            </button>
							                            </div>
                                                    </div>
                                                    <div class="col-md-12">
							                            <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="message">
								                            <strong>Success!</strong> {{message}}
								                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
									                            <span aria-hidden="true">&times;</span>
								                            </button>
							                            </div>
                                                    </div>
                                                </div> 
                                                <div class="row">
													<div class="col-md-12">
														<div class="form-group">
															<label>Name <span class="text-danger">*</span></label>
															<input class="form-control"  v-model.trim="$v.fullName.$model" type="text">
														</div>
                                                        <div v-if="submitted && !$v.fullName.required" class="invalid-feedback">Name is required</div>
													</div>
													<div class="col-md-12">
														<div class="form-group">
															<label>Address <span
																	class="text-danger">*</span></label>
															<textarea class="form-control"  v-model.trim="$v.address.$model" rows="4" />
														</div>
                                                        <div v-if="submitted && !$v.address.required" class="invalid-feedback">Address is required</div>
													</div>
                          <div class="col-md-12">
														<div class="form-group">
															<label>Phone Number <span class="text-danger">*</span></label>
															<input class="form-control"  v-model.trim="$v.phone.$model" type="text">
														</div>
                                                        <div v-if="submitted && !$v.phone.required" class="invalid-feedback">Phone Number is required</div>
													</div>
                          <div class="col-md-12">
														<div class="form-group">
															<label>Relationship <span class="text-danger">*</span></label>
															<input class="form-control"  v-model.trim="$v.relationship.$model" type="text">
														</div>
                                                        <div v-if="submitted && !$v.relationship.required" class="invalid-feedback">Relationship is required</div>
													</div>
												</div>
											</div>
										</div>
									<div class="submit-section">
										<button class="btn btn-primary submit-btn" type="submit">Submit</button>
									</div>
								</form>
							</div>
						</div>
				</v-dialog>
				<!-- /Family Info Modal -->
</template>


<script>
import { required, sameAs } from 'vuelidate/lib/validators';
import { employeeService } from '@/services/employeeService';
import {organizationService} from '@/services/organizationService';
  export default {
    props: {
        model: {},
        id: 0,
		dialog: Boolean,
		method: { type: Function }
    },
    data() {
      return {
		  modalDialog: this.dialog,
		  employee: null,
      employeeId: this.id,
      fullName: (this.model) ? this.model.fullName : '',
      address: (this.model) ? this.model.address : '',
      relationship: (this.model) ? this.model.relationship : '',
      phone: (this.model) ? this.model.phone : '',
      error: '',
      message: '',
		  banks: [],
      submitted: false
      }
    },
    validations: {
        fullName: { required },
        address: { required },
        relationship: { required },
        phone: { required }
    },
    mounted() {
		this.$emit('update:employee', this.employee);
		this.$emit('update:NextOfKinDialog', this.dialog);
    this.fullName = this.model.fullName
    this.address = this.model.address
    this.relationship = this.model.relationship
    this.phone = this.model.phone
    },
    methods: {
        postNextOfKin() {
            this.submitted = true;
            // console.log(this.Id)
            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            if(this.model){

                employeeService.updateEmployeeNextOfKin(this.model.id, this.employeeId, this.fullName, this.address, this.relationship, this.phone)
                .then(model => { this.message = 'Next of Kin Info update successfully!'
					employeeService.getEmployeeDetail(this.employeeId)
            	.then(
                model => { 
					this.employee = model;
					if(!this.employee.employeePension){
						this.employee.employeePension = {id: 0, pensionNo: "", employeeRate: 0, pensionManager: ""}
					}
					if(!this.employee.employeeStatutory){
						this.employee.employeeStatutory = {id: 0, salaryBasis: "", salaryAmount: 0.00 }
					}
					if (!this.employee.employeeTax) {
                    this.employee.employeeTax = {
                      id: 0,
                      tin: "",
                      taxCode: "",
                      taxOffice: "",
                    tax: {}
                    }
                  }else{
                    this.employee.employeeTax.tax = { taxOffice: this.employee.employeeTax.taxCode, description: this.employee.employeeTax.taxOffice}
                  }
				},
                error => { this.error = error })
				},
                    error => { this.error = error})
            }else{
                employeeService.addEmployeeNextOfKin(this.employeeId, this.fullName, this.address, this.relationship, this.phone)
                .then(model => { this.message = 'Next of Kin Info create successfully!'
					employeeService.getEmployeeDetail(this.employeeId)
            	.then(
                model => { 
					this.employee = model;
          if(!this.employee.passportPhoto){
              this.employee.passportPhoto = "../../assets/profiles/avatar-02.jpg"
          }
					if(!this.employee.employeePension){
						this.employee.employeePension = {id: 0, pensionNo: "", employeeRate: 0, pensionManager: ""}
					}
					if(!this.employee.employeeStatutory){
						this.employee.employeeStatutory = {id: 0, salaryBasis: "", salaryAmount: 0.00 }
					}
					if (!this.employee.employeeTax) {
                    this.employee.employeeTax = {
                      id: 0,
                      tin: "",
                      taxCode: "",
                      taxOffice: "",
                    tax: {}
                    }
                  }else{
                    this.employee.employeeTax.tax = { taxOffice: this.employee.employeeTax.taxCode, description: this.employee.employeeTax.taxOffice}
                  }
                  employeeService.getEmployeeOtherDetail(this.$route.params.id).then(
        model => {

          this.employee.employeeBank = model.employeeBank;
          this.employee.employeeTax = model.employeeTax;
          this.employee.employeePension = model.employeePension;
          this.employee.employeeStatutory = model.employeeStatutory;
          this.employee.employeeEducations = model.employeeEducations;
          this.employee.employeeExperiences = model.employeeExperiences;
          this.employee.employeeEmergencies = model.employeeEmergencies;
          this.employee.employeeFamilies = model.employeeFamilies;
          this.employee.employeeGLIs = model.employeeGLIs;
          this.employee.employeeHMO = model.employeeHMO;
          this.employee.employeeNextOfKin = model.employeeNextOfKin;
          this.employee.employeeNHF = model.employeeNHF;

          console.log(this.employee.employeeBank);

          if (!this.employee.employeePension) {
            this.employee.employeePension = {
              id: 0,
              pensionNo: "",
              employeeRate: "0",
              pensionManager: ""
            };
          } else {
            this.employee.employeePension.employeeRate = model.employeePension.employeeRate.toString();
          }
          if (!this.employee.employeeStatutory) {
            this.employee.employeeStatutory = {
              id: 0,
              salaryBasis: "",
              salaryAmount: 0.0
            };
          }
          if (!this.employee.employeeTax) {
            this.employee.employeeTax = {
              id: 0,
              tin: "",
              taxCode: "",
              taxOffice: "",
              tax: {}
            };
          } else {
            this.employee.employeeTax.tax = {
              taxOffice: this.employee.employeeTax.taxCode,
              description: this.employee.employeeTax.taxOffice
            };
          }
          if (!this.employee.employeeNHF) {
            this.employee.employeeNHF = {
              id: 0,
              nhfNo: "",
              state: ""
            };
          }
          this.method(this.employee);
        },
        error => {
          this.error = error;
        }
      );
    
				},
                error => { this.error = error })
				},
                    error => { this.error = error})
            }
        },

        
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/employees/NextOfKinInfoModal.vue